import LTR from "@brand-icons/ploom/ui-cross/ui-cross-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiCrossIcon = iconFactory("UiCrossIcon", LTR);
